import React from 'react';
import { Box, Text } from '@stitch-fix/mode-react';
import classNames from 'classnames';
import {
  CloudinaryImageWrapper,
  type CloudinaryImageWrapperProps,
} from '../CloudinaryImageWrapper';
import styles from './styles.module.scss';
import { isNonEmptyString } from '../../utils/helpers';

export type ShoppableItemDetails = {
  brand?: string;
  href?: string;
  name?: string;
  price?: string;
};

export type ShoppableItemProps = ShoppableItemDetails & {
  image: CloudinaryImageWrapperProps;
};

const hasShoppableItemDetails = ({
  brand,
  name,
  price,
}: ShoppableItemDetails) =>
  isNonEmptyString(brand) || isNonEmptyString(name) || isNonEmptyString(price);

export const ShoppableItem = ({
  image,
  href,
  ...itemDetails
}: ShoppableItemProps) => {
  const hasLink = isNonEmptyString(href);
  const linkProps = hasLink
    ? ({ as: 'a', href } as const)
    : ({ as: 'div' } as const);

  return (
    <Box
      className={classNames(styles.product, {
        [styles.hasProductLink]: hasLink,
      })}
      {...linkProps}
    >
      <Box className={styles.productImage}>
        <CloudinaryImageWrapper
          src={image.src}
          alt={image.alt}
          sources={image.sources}
          aspectRatio={image.aspectRatio}
          cloudinaryAsset={image.cloudinaryAsset}
          maxContainerWidth={image.maxContainerWidth}
          sizes={image.sizes}
          imageProps={image.imageProps}
        />
      </Box>
      {hasShoppableItemDetails(itemDetails) && (
        <Box className={styles.productDetails} mt={0.75}>
          <Text setting="body-small" maxLines={3}>
            {itemDetails.brand && (
              <strong className={styles.brand}>{itemDetails.brand}</strong>
            )}
            {itemDetails.name}
          </Text>
          <Text setting="body-small">{itemDetails.price}</Text>
        </Box>
      )}
    </Box>
  );
};
